module.exports = __webpack_public_path__ + "static/media/forgot-password.80c13eaa.svg";